export const useAlternateLayout = () => {
  const LAYOUT_TOGGLE_STORAGE_KEY = "ENABLE_ALTERNATE_LAYOUT";
  return localStorage.getItem(LAYOUT_TOGGLE_STORAGE_KEY) === "true";
};
